import React from "react";
import { useState, useContext, createContext } from "react";

const LoadingSpinnerContext = createContext(null);

export const LoadingSpinnerProvider = ({ children }) => {
  const [globalLoading, setGlobalLoading] = useState(false)

  return <LoadingSpinnerContext.Provider value={{ globalLoading, setGlobalLoading }}>{children}</LoadingSpinnerContext.Provider>;
};

export const useLoadingSpinnerContext = () => useContext(LoadingSpinnerContext);
